import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Moment from 'moment';
import NotaItem from './NotaItem';
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { useQuery } from '../hooks/useQuery';
import {
  RASCUNHO,
  PENDENTE,
  PENDENCIA_GESTOR,
  PENDENCIA_FORNECEDOR,
  encryptData,
  obterCorPorStatus,
} from '../utils';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import TextsmsIcon from '@mui/icons-material/Textsms';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Chip, Grid } from '@mui/material';
import Box from '@mui/material/Box';
import { handleHttpError } from '../utils';
import CustomizedDialogs from '../components/ModalAlert';
import { useAuth } from '../hooks/useAuth';
import ArticleIcon from '@mui/icons-material/Article';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CustomChip from './CustomChip';

const RowNotaFiscal = ({
  nota,
  index,
  onClickEdit,
  listar,
  contratoId,
  bloqueioEnvio = false,
  cnpj,
  clickExpand,
}) => {
  const [statuses, setStatuses] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const { obterHistoricoStatusNotaFiscal, atualizarNota, deletarNota } =
    useQuery();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [message, setMessage] = React.useState('');
  const [type, setType] = React.useState('');
  const [show, setShow] = React.useState(false);
  const { isUsuarioSebrae } = useAuth();

  const navigate = useNavigate();

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onCloseModal = () => {
    setShow(false);
    listar(contratoId);
  };

  const handleDeletar = async (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    try {
      const result = await deletarNota(nota.id);

      if (result && result.data && result.data.success) {
        setMessage('Nota fiscal excluída com sucesso');
        setType('success');
        setShow(true);
        return;
      } else {
        setMessage(result.data.message);
        setType('error');
        setShow(true);
        return;
      }
    } catch (error) {
      setMessage(handleHttpError(error));
      setType('error');
      setShow(true);
    }
  };

  const handleCancelar = async (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    navigate(`/dashboard/cancelar-nota/${nota.id}`);
  };

  const canEdit = (status) => {
    if (bloqueioEnvio) {
      return [
        PENDENCIA_FORNECEDOR,
        'PENDENCIA DO FORNECEDOR',
        PENDENCIA_GESTOR,
      ].includes(status);
    }

    return [
      PENDENTE,
      RASCUNHO,
      PENDENCIA_FORNECEDOR,
      'PENDENCIA DO FORNECEDOR',
      PENDENCIA_GESTOR,
    ].includes(status);
  };

  const handleCutString = (str) => {
    if (!str) return '';
    return str.length > 30 ? `${String(str).substring(0, 16)}...` : str;
  };

  return (
    <tr
      style={{
        border: '2px solid #FAFCFF',
        background: index % 2 === 1 ? 'white' : '#f0eded',
      }}
    >
      <td
        align="center"
        width="10%"
        style={{
          color: '#0e72b8',
        }}
      >
        <CustomizedDialogs
          content={message}
          btnTxt={'Ok'}
          type={type}
          onClick={onCloseModal}
          handleClose={onCloseModal}
          visible={show}
        />
        <span>{handleCutString(nota.numero_nf)}</span>
      </td>
      <td align="center" width="15%">
        {nota.numero_processo_fluig || '-'}
      </td>
      <td width="15%" align="center">
        {/* <CustomChip label={nota.situacao_nf} status={nota.situacao_nf} /> */}
        <Button
          style={{
            borderRadius: 20,
            fontSize: 10,
          }}
          variant="outlined"
          color={obterCorPorStatus(nota.situacao_nf)}
        >
          {nota.situacao_nf}
        </Button>
      </td>
      <td align="center">
        <span>{nota.last_user}</span>
      </td>
      <td align="center">R$ {nota.valor_servico}</td>
      <td align="center">
        <span>{nota.created_at_formatted || '-'}</span>
      </td>
      <td>
        <Grid display="flex" margin={0}>
          {canEdit(nota.situacao_nf) ||
          (nota && nota.can_cancel) ||
          (isUsuarioSebrae && nota && nota.numero_processo_fluig) ? (
            <IconButton
              aria-label="more"
              id={nota.numero_nf}
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MoreVertIcon />
            </IconButton>
          ) : null}
          <Menu
            id="long-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
          >
            {!canEdit(nota.situacao_nf) && (
              <MenuItem
                onClick={() => {
                  navigate(
                    `/dashboard/nota/visualizar/${encryptData(nota.id)}`,
                  );
                }}
              >
                <MoreHorizIcon color="primary" />
                <span style={{ marginLeft: '10px' }}>Visualizar</span>
              </MenuItem>
            )}

            {canEdit(nota.situacao_nf) && (
              <MenuItem
                onClick={() => {
                  handleClose();
                  onClickEdit();
                }}
              >
                <EditIcon color="primary" />
                <span style={{ marginLeft: '10px' }}>Editar</span>
              </MenuItem>
            )}
            {nota && nota.situacao_nf == 'RASCUNHO' ? (
              <MenuItem onClick={handleDeletar}>
                <DoNotDisturbIcon color="primary" />
                <span style={{ marginLeft: '10px' }}>Excluir nota fiscal</span>
              </MenuItem>
            ) : nota.can_cancel ? (
              <MenuItem onClick={handleCancelar}>
                <DoNotDisturbIcon color="primary" />
                <span style={{ marginLeft: '10px' }}>Cancelar nota</span>
              </MenuItem>
            ) : null}
            {isUsuarioSebrae && nota && nota.numero_processo_fluig ? (
              <MenuItem
                onClick={(e) => {
                  handleClose(e);

                  window.open(
                    `${process.env.REACT_APP_URL_FLUIG}/portal/p/1/pageworkflowview?app_ecm_workflowview_detailsProcessInstanceID=${nota.numero_processo_fluig}`,
                    '_blank',
                  );
                }}
              >
                <ArticleIcon color="primary" />
                <span style={{ marginLeft: '10px' }}>
                  Abrir workflow do fluig
                </span>
              </MenuItem>
            ) : null}
          </Menu>

          <IconButton onClick={() => clickExpand()}>
            <ExpandMoreIcon />
          </IconButton>
        </Grid>
      </td>
    </tr>
  );
};

export default RowNotaFiscal;
